import styled from "styled-components";

import {
  Box,
  FlexContainer,
  FlexDiv,
  FlexSection,
} from "../../../components/Atoms";

export const Wrapper = styled(FlexSection)`
  background-color: ${({ theme }) => theme?.colorsV2?.gray?.shade_50};
  padding: 80px 16px;
  @media only screen and (max-width: 1079px) {
    padding: 16px 0 0;
    background-color: ${({ theme }) => theme?.colors?.white};
  }
`;

export const WrapperContainer = styled(FlexContainer)`
  @media only screen and (max-width: 1079px) {
    padding: 0;
  }
`;

export const TwoColumnSection = styled(FlexDiv)`
  width: 100%;
  @media only screen and (max-width: 1079px) {
    flex-direction: column;
  }
`;

export const LeftSectionWrapper = styled(Box)`
  flex: 1;
  max-width: 50%;
  padding-right: 8px;
  @media only screen and (max-width: 1079px) {
    max-width: unset;
    padding-right: 0;
  }
`;

export const RightSectionWrapper = styled(Box)`
  flex: 1;
  max-width: 50%;
  padding-left: 8px;
  @media only screen and (max-width: 1079px) {
    max-width: unset;
    padding-left: 0;
  }
`;
